/**
 * Enum for audio recording status
 */
export enum AudioPlayerStatus {
    DISCARD_RECORDING = 'discardRecording',
    STOP_RECORDING = 'stopRecording',
}